export default __webpack_public_path__ + "static/media/portfolio6.df486278.jpg";